import React from "react";
import { Accordion } from "react-bootstrap";
import PageBanner from "../commoncomponents/Pagebanner"; // Adjust path as needed
import "@fontsource/poppins"; // Ensure this is installed

function Faq() {
  return (
    <>
      {/* Banner at the top */}
      <div>
        <PageBanner title="FAQ" />
      </div>

      {/* FAQ Section */}
      <div className="container my-5">
        <h2
          className="text-center mb-4"
          style={{ fontFamily: "'Poppins', sans-serif", fontWeight: "600" }}
        >
          Your Questions, Answered
        </h2>

        <Accordion defaultActiveKey="0">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              1. What services does Varay QC offer?
            </Accordion.Header>
            <Accordion.Body>
              We specialize in product sourcing, quality inspections, packaging
              supervision, and export coordination for buyers around the world,
              primarily in the tile and industrial sectors.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              2. Which types of tiles do you inspect?
            </Accordion.Header>
            <Accordion.Body>
              We inspect all major tile categories, including ceramic wall
              tiles, vitrified tiles, polished porcelain, double charged, full
              body, glazed, and slab tiles.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              3. Do you support packaging inspection?
            </Accordion.Header>
            <Accordion.Body>
              Yes, we ensure products are packed as per international standards.
              We check box labeling, shrink wrapping, palletization, and
              container loading.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              4. What quality standards do you follow?
            </Accordion.Header>
            <Accordion.Body>
              Our inspections follow EN ISO standards including EN ISO 10545
              series for tiles and mechanical/visual checks aligned with buyer
              specifications.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>5. Where are you located?</Accordion.Header>
            <Accordion.Body>
              Our team is active throughout India, especially in Morbi, Gujarat
              — a global hub for ceramic tile manufacturing.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              6. Can you help international buyers with sourcing?
            </Accordion.Header>
            <Accordion.Body>
              Absolutely! We connect international buyers with reliable Indian
              manufacturers, ensuring transparent deals and strong supplier
              relationships.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>
              7. Do you provide real-time updates during inspection?
            </Accordion.Header>
            <Accordion.Body>
              Yes, we share real-time reports, photos, and videos from factory
              floors via WhatsApp or email to keep you updated throughout the
              process.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>
              8. What is your inspection turnaround time?
            </Accordion.Header>
            <Accordion.Body>
              Standard inspections are completed within 24–48 hours after
              scheduling. Urgent inspections can be arranged based on
              availability.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="8">
            <Accordion.Header>
              9. Is pre-shipment inspection available?
            </Accordion.Header>
            <Accordion.Body>
              Yes, we offer detailed pre-shipment inspections to verify
              quantity, quality, packaging, and loading process before container
              sealing.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="9">
            <Accordion.Header>
              10. How can I contact you for a quote or consultation?
            </Accordion.Header>
            <Accordion.Body>
              You can reach out via our website’s contact form, WhatsApp, or
              email. We respond promptly to discuss your needs and share a
              custom plan.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </div>
    </>
  );
}

export default Faq;
